import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export async function openExternal(url) {
  if (!url) return;
  if (Capacitor.isNativePlatform()) {
    try {
      await Browser.open({ url });
      return;
    } catch {}
  }
  window.open(url, '_blank', 'noopener');
}
